import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useContext } from 'react';
import { TableContext } from './tableContext.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function TableHeader(props) {
  var _useContext = useContext(TableContext),
      renderers = _useContext.decoratedRenderers,
      columns = _useContext.decoratedColumns,
      headerRowRenderer = _useContext.headerRowRenderer,
      getHeaderProps = _useContext.getHeaderProps,
      refs = _useContext.refs;

  var HeaderWrapper = renderers.header.wrapper;
  return /*#__PURE__*/React.createElement(HeaderWrapper, getHeaderProps(_objectSpread(_objectSpread({}, props), {}, {
    innerRef: refs.header
  })), headerRowRenderer(columns, {}));
}

export default TableHeader;
//# sourceMappingURL=TableHeader.js.map
